<template>
  <div class="view-checkout-builder">
    <div class="my-9 text-center" v-if="loading">
      <b-spinner variant="primary" />
    </div>

    <div v-else class="builder-container">
      <checkout-builder-header />

      <div class="flex-fill overflow-y-scroll">
        <aside class="d-none d-lg-block" v-if="editing">
          <settings-menu />
        </aside>
        <section :class="{ editing }">
          <checkout-builder />
        </section>
      </div>

      <checkout-builder-footer v-if="editing" />
    </div>
  </div>
</template>

<script>
import CheckoutBuilder from "@/components/product/checkout/builder/CheckoutBuilder.vue";
import CheckoutBuilderFooter from "@/components/product/checkout/builder/CheckoutBuilderFooter.vue";
import CheckoutBuilderHeader from "@/components/product/checkout/builder/CheckoutBuilderHeader";
import SettingsMenu from "@/components/product/checkout/builder/SettingsMenu.vue";
import { mapState } from "vuex";

export default {
  components: {
    CheckoutBuilderHeader,
    CheckoutBuilderFooter,
    CheckoutBuilder,
    SettingsMenu
  },
  data() {
    return {
      loading: false,
      menuModal: false
    };
  },
  computed: {
    ...mapState("checkoutBuilder", ["editing"])
  },
  methods: {
    setCheckoutState(checkout_build) {
      this.$store.dispatch("checkoutBuilder/setCheckoutState", checkout_build);
    }
  },
  mounted() {
    this.loading = true;
    this.$store.commit("checkoutBuilder/setEditing", true);
    this.$store
      .dispatch("product/getProduct", this.$route.params.id)
      .then(({ checkout_build }) => {
        this.setCheckoutState({ ...checkout_build });
      })
      .finally(() => (this.loading = false));
  }
};
</script>

<style lang="scss">
.builder-container {
  display: flex;
  position: relative;
  flex-direction: column;
  height: calc(100vh - 72px);

  @media screen and (min-width: 992px) {
    background-image: repeating-linear-gradient(
        to bottom,
        transparent,
        transparent 5px,
        #d7d7d73d 1px,
        #d7d7d73d 6px
      ),
      repeating-linear-gradient(
        to right,
        transparent,
        transparent 5px,
        #d7d7d73d 5px,
        #d7d7d73d 6px
      );
  }

  aside {
    top: 72px;
    z-index: 20;
    width: 343px;
    position: absolute;
    backdrop-filter: blur(12px);
    height: calc(100vh - 72px - 72px);
    box-shadow: 16px 16px 32px 0px rgba(0, 0, 0, 0.08);
    border-right: 1px solid var(--Semantic-Neutral-100, #d7d7d7);
    background: var(--Surface-Transparent-24, rgba(255, 255, 255, 0.92));
  }

  @media screen and (max-width: 991px) {
    height: calc(100vh - 60px);
  }

  section {
    min-height: 100%;
    &.editing {
      @media screen and (min-width: 992px) {
        margin-left: 343px;
      }
    }
  }
}
.modal-body {
  padding: 1rem 0;
}
</style>
